var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import React from "react";
import { ST_Table_CSS } from "../../css/NavigationObjectCss";
import { TeamsBL } from "./TeamsBL";
import { formatAmount } from "../../shared/Utilites";
import { useTranslation } from "react-i18next";
var MobileViewTeamsTable = function (props) {
    var headerArray = props.headerArray, dataArray = props.dataArray;
    var _a = TeamsBL(), shopCurrency = _a.shopCurrency, currency = _a.currency;
    var t = useTranslation().t;
    var getDynamicTableCellForTeams = function (headerIndex, item) {
        var returnCell;
        switch (headerIndex) {
            case 0:
                returnCell = _jsx(TableCell, { children: item === null || item === void 0 ? void 0 : item.orderNumber });
                break;
            case 1:
                returnCell = _jsx(TableCell, { children: item === null || item === void 0 ? void 0 : item.orderDate });
                break;
            case 2:
                returnCell = _jsx(TableCell, { children: item === null || item === void 0 ? void 0 : item.CustomerName });
                break;
            case 3:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount((item === null || item === void 0 ? void 0 : item.subtotal) || 0, currency, shopCurrency) }));
                break;
            case 4:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount((item === null || item === void 0 ? void 0 : item.commission) || 0, currency, shopCurrency) }));
                break;
            case 5:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount((item === null || item === void 0 ? void 0 : item.TeamManagerCommission) || 0, currency, shopCurrency) }));
                break;
            case 6:
                returnCell = _jsx(TableCell, { children: item === null || item === void 0 ? void 0 : item.CommissionType });
                break;
        }
        return returnCell;
    };
    var teamOrders = function () {
        var tableStructure = (_jsx(TableContainer, __assign({ sx: ST_Table_CSS, className: "Table_Container_Margin" }, { children: _jsx(Table, { children: dataArray !== null && dataArray !== undefined && (dataArray === null || dataArray === void 0 ? void 0 : dataArray.length) > 0 ? (dataArray === null || dataArray === void 0 ? void 0 : dataArray.map(function (item, index) { return (_jsxs(_Fragment, { children: [_jsx(TableBody, __assign({ sx: { backgroundColor: "whitesmoke" } }, { children: _jsx(React.Fragment, { children: headerArray === null || headerArray === void 0 ? void 0 : headerArray.map(function (header, headerIndex) { return (_jsxs(TableRow, __assign({ className: "MobileViewTableCell", sx: { display: (header === null || header === void 0 ? void 0 : header.hidden) ? "none" : "table-row" } }, { children: [_jsx(TableCell, { children: _jsxs("b", { children: [header.label, ":"] }) }), getDynamicTableCellForTeams(headerIndex, item)] }), header.label + headerIndex)); }) }, index) })), _jsx("br", {})] })); })) : (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ className: "BorderBottom" }, { children: t("no_orders_to_show") })) }) })) }) })));
        return tableStructure;
    };
    return teamOrders();
};
export default MobileViewTeamsTable;
